import React from 'react';
import classNames from 'clsx';
import { Checkbox, FormGroup } from '@material-ui/core';
import ReactPlaceholder from 'react-placeholder/lib/ReactPlaceholder';

import { DictionaryEntry } from 'app/services/dict.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { CheckboxGroupControlProps } from './CheckboxGroupControl.interfaces';
import { InputPlaceholder } from 'app/components/InputPlaceholder';
import { useCheckboxGroupControl } from 'app/shared/hooks/controls/useCheckboxGroupControl';
import { useStyles } from './CheckboxGroupControl.styles';
import { FieldsEnum } from 'app/shared/enums';

export default function CheckboxGroupControl(props: CheckboxGroupControlProps) {
  const classes = useStyles();

  const {
    helperText,
    input,
    isLoading,
    label,
    meta,
    subLabel,
    tooltip,
    width,
    questionKey,
  } = props;

  const {
    handleChange,
    handleClick,
    isChecked,
    isDictionaryEntryDisabled,
    renderCheckboxes,
  } = useCheckboxGroupControl(props);

  const isVerticalDirection = [FieldsEnum.TravelTransportForms].includes(
    questionKey as FieldsEnum
  );

  const isQuestionOptionsBold = [FieldsEnum.InsuranceScope].includes(
    questionKey as FieldsEnum
  );

  return (
    <ReactPlaceholder
      ready={!isLoading}
      customPlaceholder={<InputPlaceholder width={width} />}
    >
      <ControlContainer
        inputId={input.name}
        withoutHtmlFor
        tooltip={tooltip}
        label={label}
        width={width}
        subLabel={subLabel}
        helperText={helperText}
        meta={meta}
        filled={input.value && input.value.length}
        className={classes.controlContainer}
      >
        <FormGroup
          row={!isVerticalDirection}
          aria-labelledby={`${input.name}-label`}
        >
          {renderCheckboxes(renderCheckbox)}
        </FormGroup>
      </ControlContainer>
    </ReactPlaceholder>
  );

  function renderCheckbox(entry: DictionaryEntry) {
    const activeClass = isChecked(entry.key) ? classes.active : '';

    return (
      <div
        onClick={handleClick}
        tabIndex={0}
        key={entry.key.toString()}
        className={classNames(
          classes.checkboxRoot,
          classes.boxRoot,
          activeClass,
          'focusVisibleOutline',
          {
            [classes.disabled]: isDictionaryEntryDisabled(entry.key),
            [classes.boldText]: isQuestionOptionsBold,
            [classes.checkboxRootVerticalDirection]: isVerticalDirection,
          }
        )}
        onKeyDown={(e) => {
          if (
            e.target === e.currentTarget &&
            (e.key === 'Enter' || e.key === ' ')
          ) {
            e.preventDefault();
            handleChange(entry.key);
          }
        }}
      >
        <div onClick={() => handleChange(entry.key)}>
          <Checkbox
            id={entry.key.toString()}
            name={input.name}
            color="primary"
            checked={isChecked(entry.key)}
            onChange={() => handleChange(entry.key)}
            className={classNames({
              [classes.verticalDirection]: isVerticalDirection,
            })}
            inputProps={{
              tabIndex: -1,
            }}
          />
        </div>
        <label className={classes.label} htmlFor={entry.key.toString()}>
          {entry.value}
        </label>
      </div>
    );
  }
}
